
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/goods",
      function () {
        return require("private-next-pages/goods.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/goods"])
      });
    }
  